import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

// WorkflowStep: one of the four cards in the "How Aakash Drishti works" section.
export function WorkflowStep({ index, Icon, title, description, details }) {
  return (
    <Card className="p-6 border-border relative overflow-hidden" data-testid={`workflow-step-${index}`}>
      <div className="absolute -top-2 -right-2 font-display font-semibold text-[80px] leading-none text-primary/8 select-none pointer-events-none">
        {index}
      </div>
      <div className="flex items-center gap-3">
        <div className="rounded-lg bg-primary/10 text-primary p-2.5">
          <Icon size={20} />
        </div>
        <Badge variant="outline" className="text-[10px] uppercase tracking-widest">Stage {index}</Badge>
      </div>
      <div className="mt-4 font-display font-semibold text-[19px]">{title}</div>
      <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{description}</p>
      <ul className="mt-4 space-y-1.5 text-xs text-muted-foreground">
        {details.map((d) => (
          <li key={d} className="flex items-start gap-2">
            <span className="mt-1.5 h-1 w-1 rounded-full bg-primary shrink-0" />
            <span>{d}</span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
